import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';
import { useState } from 'react';

const useAddExpenseReportProof = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addExpenseReportProof = async (file) => {
    setLoading(true);
    setError(null);
    const formData = new FormData();
    formData.append("expenseReport", file);

// console.log("addExpenseReportProof formData=", formData, "file = ", file)
    try {
      const response = await authenticatedFetch(window.ENV.BACKEND_URL+'/api/secured/users/expense/expenseReportProof', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Error uploading expense report proof');
      }

      const data = await response.json();
      return { data, error: null }; // data contains the UUID of the uploaded proof
    } catch (err) {
      setError(err.message);
      return { data: null, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  return { addExpenseReportProof, loading, error };
};

export default useAddExpenseReportProof;
